// extracted by mini-css-extract-plugin
export default {"title":"QuotationsCard_title__Ezwme","right":"QuotationsCard_right__T2uK+"};